<template>
	<div class="spinnerWrap flex vertical-align justify-center">
		<div class="spinner">
			<div class="bounce1"></div>
			<div class="bounce2"></div>
			<div class="bounce3"></div>
		</div>
	</div>
</template>

<script>
	
	export default {

		/*
		** Set the component name
		*/

		name: 'FormLoadingSpinner',

	}

</script>